/* ============================================================
   AVORA HOME — Dynamic Product Page Components JS
   Scroll reveal, Before/After slider
   ============================================================ */

/* === Scroll Reveal Observer === */
(function() {
  var reveals = document.querySelectorAll('.avora-dc-reveal');
  if (!reveals.length) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -40px 0px'
  });

  reveals.forEach(function(el) { observer.observe(el); });
})();

/* === Before/After Slider === */
(function() {
  document.querySelectorAll('.avora-dc-beforeafter').forEach(function(container) {
    var handle = container.querySelector('.avora-dc-beforeafter__handle');
    var divider = container.querySelector('.avora-dc-beforeafter__divider');
    var afterLayer = container.querySelector('.avora-dc-beforeafter__after');
    if (!handle || !afterLayer) return;

    function updatePosition(x) {
      var rect = container.getBoundingClientRect();
      var percent = ((x - rect.left) / rect.width) * 100;
      percent = Math.max(2, Math.min(98, percent));

      handle.style.left = percent + '%';
      if (divider) divider.style.left = percent + '%';
      afterLayer.style.clipPath = 'inset(0 ' + (100 - percent) + '% 0 0)';
    }

    function onMouseMove(e) {
      e.preventDefault();
      updatePosition(e.clientX);
    }

    function onMouseUp() {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    }

    function onTouchMove(e) {
      updatePosition(e.touches[0].clientX);
    }

    function onTouchEnd() {
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', onTouchEnd);
    }

    handle.addEventListener('mousedown', function(e) {
      e.preventDefault();
      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
    });

    handle.addEventListener('touchstart', function() {
      window.addEventListener('touchmove', onTouchMove, { passive: true });
      window.addEventListener('touchend', onTouchEnd);
    }, { passive: true });

    /* Allow clicking anywhere on the container to reposition */
    container.addEventListener('click', function(e) {
      if (e.target === handle) return;
      updatePosition(e.clientX);
    });
  });
})();
